import { heroLead, heroSideStories } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section id="top" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-center gap-3 md:mb-8">
          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-radar-line text-sm" />
            </span>
            正在围观
          </span>
          <span className="text-xs text-foreground-500 md:text-sm">
            每天更新 · 吃瓜群众的茶余饭后谈资在这里集合
          </span>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="flex flex-col justify-between lg:col-span-7">
            <div>
              <p className="mb-3 text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
                {heroLead.tag}
              </p>
              <h2 className="font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-4xl lg:text-[42px]">
                {heroLead.title}
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
                {heroLead.summary}
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500 md:text-sm">
                {heroLead.meta.map((m) => (
                  <span key={m} className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-time-line text-sm" />
                    </span>
                    {m}
                  </span>
                ))}
              </div>

              <div className="mt-7 flex flex-wrap gap-3">
                <a
                  href="#discussion"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  进讨论区聊两句
                </a>
                <a
                  href="#trending"
                  className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  看今日热帖榜
                </a>
              </div>
            </div>

            <div className="mt-9 border-t border-background-200/80 pt-6">
              <ul className="flex flex-col divide-y divide-background-200/70">
                {heroSideStories.map((s) => (
                  <li key={s.id} className="py-3 first:pt-0 last:pb-0">
                    <a href="#discussion" className="group flex items-start gap-3">
                      <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center text-primary-500">
                        <i className="ri-arrow-right-s-line text-lg" />
                      </span>
                      <span className="flex-1">
                        <span className="block text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
                          {s.title}
                        </span>
                        <span className="mt-1 block text-xs text-foreground-500">
                          {s.summary}
                        </span>
                      </span>
                      <span className="mt-0.5 whitespace-nowrap text-xs text-foreground-400">
                        {s.time}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative h-[320px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[420px] lg:h-full lg:min-h-[520px]">
              <img
                src={heroLead.image}
                alt={`${heroLead.title} - 黑料八卦今日话题封面`}
                title="黑料八卦今日话题封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent p-5 md:p-6">
                <div>
                  <p className="text-xs text-background-200">封面话题</p>
                  <p className="mt-1 font-heading text-lg font-semibold text-background-50">
                    今晚讨论区最热的一楼
                  </p>
                </div>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-chat-3-fill text-xl" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}